import { render, staticRenderFns } from "./PubPageEdit.vue?vue&type=template&id=3291b922&scoped=true&"
import script from "./PubPageEdit.vue?vue&type=script&lang=js&"
export * from "./PubPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./PubPageEdit.vue?vue&type=style&index=0&id=3291b922&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3291b922",
  null
  
)

export default component.exports